//frontend/src/components/ticket.jsx
import React, { useMemo } from "react";
import "./TicketPago.css";

export default function TicketPago({ ticket, onClose }) {
  const safeTicket = useMemo(() => String(ticket || ""), [ticket]);
  if (!safeTicket) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(safeTicket);
      window.dispatchEvent(
        new CustomEvent("toast", { detail: { mensaje: "Ticket copiado", tipo: "success" } })
      );
    } catch {
      window.dispatchEvent(
        new CustomEvent("toast", { detail: { mensaje: "No se pudo copiar", tipo: "error" } })
      );
    }
  };

  const handleDownload = () => {
    const blob = new Blob([safeTicket], { type: "text/plain;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `ticket_${Date.now()}.txt`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  const handlePrint = () => {
    const win = window.open("", "PRINT", "width=420,height=700");
    if (!win) return;

    // Escapamos html para que el ticket no rompa el documento
    const escaped = safeTicket
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;");

    win.document.write(`
      <html>
        <head>
          <meta charset="utf-8" />
          <title>Ticket</title>
          <style>
            :root { color-scheme: light; }
            body { margin: 0; padding: 0; background: #fff; }
            .sheet {
              width: 72mm; /* 58mm/80mm: ajusta si quieres */
              margin: 0 auto;
              padding: 6mm 4mm;
              font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
              font-size: 12px;
              line-height: 1.25;
              white-space: pre-wrap;
              word-break: break-word;
            }
            @page { margin: 0; size: auto; }
            @media print {
              .sheet { width: 72mm; padding: 0; }
            }
          </style>
        </head>
        <body>
          <pre class="sheet">${escaped}</pre>
          <script>
            window.focus();
            window.print();
            window.onafterprint = () => window.close();
          </script>
        </body>
      </html>
    `);
    win.document.close();
  };

  return (
    <div className="ticket-overlay" role="dialog" aria-modal="true">
      <div className="ticket-modal">
        <div className="ticket-head">
          <div className="ticket-title">
            <span className="ticket-badge">RECIBO</span>
            <h3>Ticket de pago</h3>
          </div>

          <button className="ticket-close" onClick={onClose} aria-label="Cerrar">
            ✕
          </button>
        </div>

        <div className="ticket-paper">
          <pre className="ticket-text">{safeTicket}</pre>
        </div>

        <div className="ticket-actions">
          <button className="ticket-btn ghost" onClick={handleCopy} type="button">
            📋 Copiar
          </button>

          <button className="ticket-btn ghost" onClick={handleDownload} type="button">
            ⬇️ Descargar
          </button>

          <button className="ticket-btn primary" onClick={handlePrint} type="button">
            🖨 Imprimir
          </button>
        </div>
      </div>
    </div>
  );
}


